import React from "react";
import { Redirect, Route, useLocation } from "react-router-dom";
import AuthService from "../utils/authService";
import routes from "../utils/routes";

export const LoginRoute = ({ component: Component, ...rest }) => {
  const location = useLocation();
  let queryParams = "";
  let redirectUrl = "";
  try {
    const queryData = Object.fromEntries(new URLSearchParams(location.search));
    if (queryData.redirect) {
      redirectUrl = queryData.redirect;
      for (const key in queryData) {
        if (queryData.hasOwnProperty(key)) {
          if (key !== "redirect") {
            const value = queryData[key];
            redirectUrl += "&" + key + "=" + value;
          }
        }
      }
    } else {
      queryParams = location.search;
    }
  } catch (e) {
    //log it
  }
  /**
   * TO-DO
   *  User route redirection login needs to change
   *  will use the route config.
   */
  if (redirectUrl && AuthService.isAuthenticated()) {
    return (
      <Route {...rest} render={(props) => <Redirect to={redirectUrl} />} />
    );
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        AuthService.isAuthenticated() ? (
          <Redirect to={routes.HOME + queryParams} />
        ) : (
          <Component {...props} />
        )
      }
    />
  );
};
export default LoginRoute;
